import React from "react";
import {Modal2} from "../modal";
import {TextLoading} from "../../funcs/utils";
import {cancelRequest, fillRequest, PendingFundsRequest} from "../../cd/CurrentOfferings/actions";


const cancelItem = (component, ticket_id, do_reply) => () => {
  let reply_text;
  if (do_reply) {
    reply_text = component.state.reply_text;
  }
  component.setState({
    doing_cancel: true,
  });

  cancelRequest(
    component.props.user.token, null, ticket_id, do_reply, reply_text)
    .then(result => {
      component.setState({
        doing_cancel: false,
        cancel_dialog: null,
      });
      if (result.status === "OK") {
        component.props.adminSettleItem(result.payload);
      } else {
        component.setState({ error_dialog: true });
        console.log(result);
      }
    })
    .catch(err => {
      component.setState({
        doing_cancel: false,
        cancel_dialog: null,
      });
      console.log("Error", err);
    })
}

const fillItem = (component, ticket_id) => () => {
  component.setState({
    doing_fill: true,
  });

  const reply_text = component.state.reply_text;
  const fill_px_usd = component.state.fill_px_usd;

  fillRequest(
    component.props.user.token, ticket_id, reply_text, fill_px_usd)
    .then(result => {
      component.setState({
        doing_fill: false,
        fill_dialog: null,
      });
      if (result.status === "OK") {
        component.props.adminSettleItem(result.payload)
      } else {
        console.log("Error", result);
        component.setState({ error_dialog: true });
      }
    }).catch(err => {
      component.setState({
        doing_cancel: false,
        cancel_dialog: null,
      });
      console.log("Error", err);
  })
}

const VerifyCancel = (props) => {
  const ticket_id = props.ticket_id;
  const component = props.component;
  const do_reply = props.do_reply;
  const cusip = props.cusip;

  const button_list = [
    {
      label: "Do Not Cancel",
      cb: () => {
        component.setState({
          cancel_dialog: null,
        })
      },
    },
    {
      label: (
        <TextLoading
          loading={component.state.doing_cancel}
          label={"Cancel Ticket"}/>
      ),
      cb: cancelItem(component, ticket_id, do_reply),
    }
  ]

  const container_style = {
    width: do_reply ? "60rem" : "30rem",
  }
  const header_style = {
    padding: "0.5rem",
  }
  const header = (
    <div>
      Cancel Ticket
    </div>);
  const area_style = {
    width: "100%",
    height: "5rem",
  }
  const textChange = (ev) => {
    component.setState({reply_text: ev.target.value});
  }

  const reply_text = do_reply
    ? (
      <div>
        <div>Enter reply text below:</div>
        <textarea
          onChange={textChange}
          value={component.state.reply_text}
          style={area_style}>
          {component.state.reply_text}
        </textarea>
      </div>)
    : null;
  return (
    <Modal2
      container_style={container_style}
      header={header}
      header_style={header_style}
      buttonList={button_list}>
      <div>
        <div>
          Cancel ticket {ticket_id} ?
        </div>
        <div style={{height: "1rem"}}/>
        <div>
          Cusip {cusip} will be removed from the Offerings grid
        </div>
        <div style={{height: "1rem"}}/>
        {reply_text}
      </div>
    </Modal2>
  )
}

const VerifyFill = props => {
  const ticket_id = props.ticket_id;
  const component = props.component;

  const button_list = [
    {
      label: "Do Not Fill",
      cb: () => {
        component.setState({
          fill_dialog: null,
        })
      },
    },
    {
      label: (
        <TextLoading
          loading={component.state.doing_fill}
          label={"Fill Ticket"}/>
      ),
      cb: fillItem(component, ticket_id),
    }
  ];

  const container_style = {
    width: "60rem",
  }
  const header_style = {
    padding: "0.5rem",
  }
  const header = (
    <div>
      Fill Ticket {ticket_id}
    </div>);
  const area_style = {
    width: "100%",
    height: "5rem",
  }

  const replyTextChange = (ev) => {
    component.setState({reply_text: ev.target.value});
  }
  const fillPxChange = (ev) => {
    component.setState({fill_px_usd: ev.target.value});
  }
  const input_style = {
    marginLeft: "2rem",
    width: "15rem",
  }

  return (
    <Modal2
      container_style={container_style}
      header={header}
      header_style={header_style}
      buttonList={button_list}>
      <div>
        <div>
          <span>Fill Price USD: </span>
          <input
            onChange={fillPxChange}
            style={input_style}
            value={component.state.fill_px_usd}/>
        </div>
        <div style={{height: "2rem"}}/>
        <div>
          <div>Enter reply text below:</div>
          <textarea
            onChange={replyTextChange}
            value={component.state.reply_text}
            style={area_style}>
            {component.state.reply_text}
          </textarea>
        </div>
      </div>
    </Modal2>
  );
}

const ErrorDialog = (props) => {
  const component = props.component;
  const container_style = {
    width: "30rem",
  }
  const header_style = {
    padding: "0.5rem",
  }
  const header = (
    <div>
      Error
    </div>);

  const button_list = [
    {
      label: "Ok",
      cb: () => {
        component.setState({
          error_dialog: false,
        })
      },
    }];

  return (
    <Modal2
      container_style={container_style}
      header={header}
      buttonList={button_list}
      header_style={header_style}>
      <div>There was an error</div>
      <div>Contact CleverAlpha Admins</div>
    </Modal2>);
}

const do_pending_funds = (component, ticket_id) => {
  component.setState({
    doing_pending_funds: true,
  });

  PendingFundsRequest(component.props.user.token, ticket_id)
    .then(result => {
      component.setState({
        doing_pending_funds: false,
        pending_funds_dialog: null,
      });
      if (result.status === "OK") {
        component.props.loadSecurityAdminItems();
      } else {
        console.log("Error", result);
      }
    });
}

const VerifyPendingFundsDialog = props => {
  const component = props.component;
  const container_style = {
    width: "30rem",
  }
  const ticket_id = component.state.pending_funds_dialog.ticket_id;

  const header_style = {
    padding: "0.5rem",
  }
  const header = (
    <div>
      Verify Pending Funds
    </div>);

  const button_list = [
    {
      label: "Cancel",
      cb: () => component.setState({ pending_funds_dialog: null }),
    },
    {
      label: (<TextLoading
        label={"Ok"}
        loading={component.state.doing_pending_funds}/>),
      cb: () => do_pending_funds(component, ticket_id),
    }];

  return (
    <Modal2
      container_style={container_style}
      header={header}
      buttonList={button_list}
      header_style={header_style}>
      <div>Set {ticket_id} to Pending Funds state</div>
    </Modal2>);
}

export { VerifyCancel, VerifyFill, ErrorDialog, VerifyPendingFundsDialog };
